import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AppRoutes } from '../const/AppRoutes';

/**
 * Garde d'authentification minimale, alignée sur la logique déjà en place dans
 * app.module.ts (route `**`) : l'app considère l'utilisateur connecté tant que
 * `id_token` est présent dans le localStorage. Utilisée pour protéger les pages
 * publiques sans slug (ex. /note-mise-a-jour) afin qu'elles ne soient visibles
 * que par un utilisateur authentifié ; sinon on redirige vers le login.
 */
export const authGuard: CanActivateFn = (): boolean | UrlTree => {
  const router = inject(Router);
  if (localStorage.getItem('id_token')) {
    return true;
  }
  return router.parseUrl('/' + AppRoutes.LOGIN);
};
